import withAPIAction from 'helpers/withAPIAction'
import { RolePackageListReq, CreateRolePackageReq, DeleteRolePackageReq, UpdateRolePackageReq } from './types'
import {
  getRolePackageListAction,
  createRolePackageAction,
  deleteRolePackageAction,
  updateRolePackageAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'

export const rolePackageListAPI = (data: RolePackageListReq, token: string, xmid: any) => {
  return withAPIAction<RolePackageListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.rolePackageList}`,
    data,
    token,
    xmid,
  })(getRolePackageListAction)
}

export const createRolePackageAPI = (data: CreateRolePackageReq, token: string, xmid: string) => {
  return withAPIAction<CreateRolePackageReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createRolePackage,
    data,
    token,
    xmid,
  })(createRolePackageAction)
}

export const deleteRolePackageAPI = (data: DeleteRolePackageReq, token: string, xmid: string) => {
  const endPoint = APIPath.deleteRolePackage.replace(':id', data.id.toString())
  return withAPIAction<DeleteRolePackageReq>({
    method: 'DELETE',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(deleteRolePackageAction)
}

export const updateRolePackageAPI = (data: UpdateRolePackageReq, token: string, xmid: string) => {
  const endPoint = APIPath.updateRolePackage.replace(':id', data.id.toString())
  return withAPIAction<UpdateRolePackageReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(updateRolePackageAction)
}
